document.addEventListener('click', async (event) => {
const link = event.target.closest('[data-rc-whatsapp]');
if (!link || link.dataset.busy) return;
event.preventDefault();
link.dataset.busy = 'true';
try {
const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js', {headers:{Accept:'application/json'}});
if (!response.ok) throw new Error('cart');
const cart = await response.json();
if (!cart.items.length) return;
const lines = ['Hallo Rotterdam Caribean, ik wil graag deze bestelling aanvragen:'];
for (const item of cart.items) {
lines.push(item.quantity + ' x ' + item.product_title + (item.variant_title && item.variant_title !== 'Default Title' ? ' — ' + item.variant_title : ''));
for (const [name,value] of Object.entries(item.properties || {})) if (value && !name.startsWith('_')) lines.push(name + ': ' + value);
}
const scope = link.closest('.cart-drawer__summary') || link.parentElement.parentElement;
const date = scope.querySelector('input[type=date]')?.value || cart.attributes?.Afhaaldatum || '';
const time = scope.querySelector('input[type=time]')?.value || cart.attributes?.Afhaaltijd || '';
const note = document.querySelector('textarea[name=note]')?.value || cart.note || '';
lines.push('Afhalen of bezorgen:', 'Gewenste datum en tijd: ' + date + ' ' + time, 'Naam:', 'Bezorgadres (bij bezorgen):');
if (note) lines.push('Opmerking: ' + note);
lines.push('Graag eerst beschikbaarheid en totaalprijs bevestigen. Daarna ontvang ik graag de betaallink.');
window.location.assign('https://wa.me/31626999872?text=' + encodeURIComponent(lines.join('\n')));
} catch { window.location.assign(link.href); } finally { delete link.dataset.busy; }
});